import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import McActions from 'store/redux/mc'
import GlobalActions from 'store/redux/global'
import { Row, Col, Form } from 'reactstrap'
import { FG, Button } from 'components'
import { translate } from 'react-i18next'
import { pageData } from 'decorators'
import { range, filter } from 'lodash'
import { rangeValueRule } from 'utils/validation'
// import MOCK_TEMPLATE from 'data/mocks/mc/newGameTemplate.json'
import AdminTemplate from '../../templates/AdminTemplate'
import './NewGame.css'

@connect(
    state => {
        const { bots: { numBots = 0, defaultValues: { maxBudget = 0, maxTime = 0 } = {} } = {} } = state.mc.newGameTemplate || {}
        const initialValues = {}
        range(1, numBots + 1).forEach(i => {
            initialValues[`bot${i}MaxBudget`] = typeof maxBudget === 'object' ? maxBudget.default : maxBudget
            initialValues[`bot${i}MaxTime`] = typeof maxTime === 'object' ? maxTime.default : maxTime
        })
        return {
            numBots,
            maxBudget,
            maxTime,
            isLoading: state.global.loading,
            initialValues
        }
    },
    {
        modalRequest: GlobalActions.request,
        save: McActions.updateGameBots
    }
)
@reduxForm({ form: 'mcNewGameStep3' })
@pageData({ title: 'New Game (3/3)' })
@translate()
export class NewGameStep3 extends PureComponent {
    componentWillMount() {
        const { maxBudget, maxTime, t } = this.props
        const maxBudgetMin = typeof maxBudget === 'object' && typeof maxBudget.min === 'number' ? maxBudget.min : undefined
        const maxBudgetMax = typeof maxBudget === 'object' && typeof maxBudget.max === 'number' ? maxBudget.max : undefined
        this.maxBudgetValidation = rangeValueRule(maxBudgetMin, maxBudgetMax, t)
        const maxTimeMin = typeof maxTime === 'object' && typeof maxTime.min === 'number' ? maxTime.min : undefined
        const maxTimeMax = typeof maxTime === 'object' && typeof maxTime.max === 'number' ? maxTime.max : undefined
        const maxTimeDefault = typeof maxTime === 'object' && typeof maxTime.default === 'number' ? maxTime.default : undefined
        this.maxTimeValidation = rangeValueRule(0, undefined, t)
        this.maxTimeHelper = filter([
            maxTimeDefault ? t('mc.newGame.step3.maxTimeHelper.default', { value: maxTimeDefault }) : null,
            maxTimeMin ? t('mc.newGame.step3.maxTimeHelper.min', { value: maxTimeMin }) : null,
            maxTimeMax ? t('mc.newGame.step3.maxTimeHelper.max', { value: maxTimeMax }) : null,
        ], x => x !== null).join('         ')
    }
    trySubmit = form => {
        const { modalRequest, t } = this.props
        modalRequest({
            title: t('modals.mcNewGameBotsConfirmation.title'),
            text: t('modals.mcNewGameBotsConfirmation.text'),
            actionBtns: [{ text: t('modals.mcNewGameBotsConfirmation.doneBtn'), action: () => this.submit(form) }, { text: t('modals.mcNewGameBotsConfirmation.cancelBtn') }]
        })
    }
    submit = form => {
        const { numBots, save } = this.props
        save({
            bots: range(1, numBots + 1).map(i => ({
                // maxBudget: form[`bot${i}MaxBudget`],
                maxBudget: 0,
                maxTime: form[`bot${i}MaxTime`]
            }))
        })
    }

    renderDecimalInput = (id, label, validate, helper) => {
        const { t } = this.props
        return (
            <FG.Text
                type="number"
                id={id}
                name={id}
                label={t(`mc.newGame.step3.${label}`)}
                helper={helper}
                required
                autoComplete="off"
                validate={validate}
            />
        )
    }

    renderBotFields = i => (
        <Fragment key={i}>
            <legend>{this.props.t('mc.newGame.step3.bot', { bot: i })}</legend>
            <Row>
                {/* <Col xs={6}>
                    {this.renderDecimalInput(`bot${i}MaxBudget`, 'maxBudget', [this.maxBudgetValidation])}
                </Col> */}
                <Col xs={6}>
                    {this.renderDecimalInput(`bot${i}MaxTime`, 'maxTime', [this.maxTimeValidation], this.maxTimeHelper)}
                </Col>
            </Row>
        </Fragment>
    )
    render() {
        const { numBots, isLoading, handleSubmit, invalid, submitting, t } = this.props

        return (
            <AdminTemplate className="NewGame Step3 px-5" backRoute="/mc">
                <h1 dangerouslySetInnerHTML={{ __html: t('mc.newGame.step3.title') }} />
                <Form onSubmit={handleSubmit(this.trySubmit)} className="pb-5">
                    {range(1, numBots + 1).map(this.renderBotFields)}
                    <div className="Action-Btns">
                        <Button type="submit" color="primary" loading={isLoading} disabled={invalid || submitting}>
                            {t('mc.newGame.step3.nextBtn')}
                        </Button>
                    </div>
                </Form>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/NewGame/NewGameStep3.js